import type { ModelConfig, Slicer } from '@swf/core/store';

export interface Config {
  requestTimeout?: number;
  trackingId?: string;
  gtmId?: string;
  gtmAuth?: string;
  gtmPreview?: string;
  sentryDsn?: string;
  sentrySampleRate?: number;
  sentryEnvironment?: string;
}

const defaultState: Config = { requestTimeout: 20000 };

export const keys = Object.keys(defaultState);

interface ConfigModel extends ModelConfig<Config> {
  selectors: typeof selectors;
  reducers: typeof reducers;
}

const reducers = {
  set: (state: Config, payload: Config = {}) => ({ ...state, ...payload })
};

const selectors = (slice: Slicer<Config>) => ({
  get() {
    return slice;
  }
});

const config: ConfigModel = {
  state: defaultState,
  reducers,
  selectors
};

export default config;
